<template>
    <div>
        <modal :name="modal_name" class="final-modal top-70" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;">
                <div class="v-modal-header align-items-center">
                    <span class="v-modal-dialog-title" style="text-transform:none !important;">Ticket Number {{notify_details.ticket_number || '-'}}</span>
                    <span @click="hideView()" class="pointer">
                        <!-- <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/close_template.svg" alt="" style="height:25px"> -->
                        <i class="icon icon-close text-white"></i>
                    </span>
                </div>
                <div class="general-section pl-0 pr-0 pb-1" style="background-color:#ffffff;border-radius:0px">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 460px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div class="general-section">
                                <dl class="row pt-2">
                                    <dt class="col-md-4 py-2">Title</dt>
                                    <dd class="col-md-8 py-2">{{notify_details.title || '-'}}</dd>
                                    <dt class="col-md-4 py-2">Assigned User Name</dt>
                                    <dd class="col-md-8 py-2">{{notify_details.assigned_to || '-'}}</dd>
                                    <dt class="col-md-4 py-2">Received Date</dt>
                                    <dd class="col-md-8 py-2">{{dates.created_date}}</dd>
                                    <dt class="col-md-4 py-2">Viewed Date</dt>
                                    <dd class="col-md-8 py-2">{{dates.modified_date}}</dd>
                                </dl>
                                <!-- <div class="px-3" >
                                    <div class="pb-2" v-if="is_html">
                                        <div v-html="notify_details.content"></div>
                                    </div>
                                    <div class="pt-2 pb-4" v-else>
                                        <div class="bottomBorder pt-2" >
                                            <div class="fw-400 pt-2 pb-2 text-black">Title</div>
                                            <div class="fw-500 text-secondary">{{notify_details.title}}</div>
                                        </div>
                                        <div class="bottomBorder pt-2" >
                                            <div class="fw-400 pt-2 pb-2 text-black">Ticket Number</div>
                                            <div class="fw-500 text-secondary">{{notify_details.ticket_number}}</div>
                                        </div>
                                        <div class="bottomBorder pt-2" >
                                            <div class="fw-400 pt-2 pb-2 text-black">Assigned User Name</div>
                                            <div class="fw-500 text-secondary">{{notify_details.assigned_to}}</div>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import moment from 'moment-timezone';
import notification from '../mixins/notification.js';
export default {
    mixins: [notification],
    props: ['modal_name', 'notification_id'],
    data() {
        return {
            notify_details: '',
            is_html: false,
            dates: {
                created_date: '',
                modified_date: ''
            }
        }
    },
    methods: {
        hideView(){
            this.$router.push({
                path: '/notifications_page',
                // query: {
                //     id: id,
                //     is_read: i
                // }
            })
            this.$modal.hide(this.modal_name);
            this.$emit('hideNotification')
        },
        async getNotificationData() {
            let params = {
                notification_id: this.notification_id
            }
            let res = await this.getNotificationDetails(params);
            this.dates.created_date = moment(res.response.created_date).format('MM/DD/YYYY hh:mm A')
            this.dates.modified_date = moment(res.response.last_modified_time).format('MM/DD/YYYY hh:mm A')
            this.notify_details = res.response.message;
            this.is_html = res.response.is_html;
        }
    },
    mounted(){
        this.getNotificationData();
    }
}
</script>

<style scoped>
.bottomBorder{
    border-bottom: 1px solid #005dae;
    padding-bottom: 5px;
}
.v-modal-header{
    background-color: #00448b !important;
}
.v-modal-dialog-title{
    color: #fff !important
}
.v-modal-header{
    padding: 10px 15px !important;
}
</style>